/* eslint-disable no-underscore-dangle */
import buildCookieObject from './buildCookieObject';
import serializeToString from './serialize';

export default class MultiValueCookie {
  private _modified: boolean = false;

  private _cookieObject: Record<string, string | null>;

  constructor(initialValue?: string) {
    this._cookieObject = buildCookieObject(initialValue) || {};
  }

  getValue(key: string) {
    return this._cookieObject[key];
  }

  setValue(key: string, value: string | null) {
    this._cookieObject[key] = value;
    this._modified = true;
    return this;
  }

  deleteValue(key: string) {
    delete this._cookieObject[key];
    this._modified = true;
    return this;
  }

  clear() {
    this._cookieObject = {};
    this._modified = true;
    return this;
  }

  isModified() {
    return this._modified;
  }

  keys() {
    return Object.keys(this._cookieObject);
  }

  serializeToString() {
    return serializeToString(this._cookieObject);
  }
}
